import { z } from 'zod';

export const WalletsResponseSchema = z.object({
  data: z.object({
    btc: z.string(),
    ltc: z.string(),
    eth: z.string(),
    heco: z.string(),
  }),
});

export type TWalletsDataResponse = z.infer<typeof WalletsResponseSchema>;
export type TWalletsData = TWalletsDataResponse['data'];
